
<div class="sxh-tighten-in-mobile">
  <div class="sx-contract__wrapper">
    <div class="sx-contract-filter">
      <!-- Filter -->
      <div class="sxl-align-left sx-table-filter__btngroup">

          <!-- Search Form -->
          <div class="sx-table-filter sxl-horizontal-stack-small sx-table-filter__left">
            <div class="">
              <span [hidden]="true">isMobile: {{isMobile}}</span>

              <form [formGroup]="searchForm">
                <div class="">
                  <mat-form-field class="sxh-full-width" appearance="outline">
                    <input matInput [autofocus]="{isMobile: isMobile}" formControlName="searchPhrase" id="field_search_serviceagreements" placeholder="{{'contracts.filter.search_phrase' | translate }}">
                      <button matSuffix class="sx-button-suffix sx-button-stripped">
                        <svg>
                          <use xlink:href="#baseline-search-24px" href="#baseline-search-24px" />
                        </svg>
                      </button>
                  </mat-form-field>
              </div>
            </form>

          </div>
        </div>
        
        <!-- Buttons -->
        <div class="sx-table-filter__right">
          <button appTrackClick sxaction="Button agreement filter" 
            mat-button class="mat-button sx-button sx-button--icon sx-button--icon-scale-medium sx-contract-filter__button-filter sx-button-semi-square"  
            [ngClass]="{'sx-filter__active': filterActive}"
            matTooltip="{{'core.button.filter' | translate}}"
            attr.aria-label="{{'core.button.filter' | translate}}" (click)="configureFilter()">
            <svg class="sx-filter__active--cil-icon" *ngIf="!filterActive">
              <use xlink:href="#cil-filter" href="#cil-filter" />
            </svg>
            <svg class="sx-filter__active--cil-square-icon" *ngIf="filterActive">
              <use xlink:href="#sx-filter-filled" href="#sx-filter-filled" />
            </svg>
          </button> 
          <button mat-button class="sx-button sx-button-semi-square" 
            id="meteringpoints_export_btn_{{paneType}}" appTrackClick sxaction="Button meteringpoint export"
            [disabled]="isExporting" 
            matTooltip="{{'core.button.export' | translate}}"
            (click)="onExport()">
            <app-spinner [showSmall]="'true'" [hidden]="!isExporting"></app-spinner>
            <svg *ngIf="!isExporting" style="transform: scale(1.5) !important;" >
              <use xlink:href="#sx-excel" href="#sx-excel" />
            </svg>
          </button>
          <button id="meteringpoints_tableview_btn_{{paneType}}" *ngIf="!tableView" appTrackClick sxaction="Button meteringpoints tableview" 
            mat-button 
            class="mat-button sx-button sx-button--icon sx-button--icon-scale-medium sx-button-semi-square"  
            matTooltip="{{'core.button.table_view' | translate}}"
            attr.aria-label="{{'core.button.table_view' | translate}}" 
            (click)="toggleView()">
            <svg>
              <use xlink:href="#sx-list-view" href="#sx-list-view" />
            </svg>
          </button>
          <button id="meteringpoints_defaultview_btn_{{paneType}}" *ngIf="tableView" appTrackClick sxaction="Button meteringpoints defaultview" 
            mat-button 
            class="mat-button sx-button sx-button--icon sx-button--icon-scale-medium sx-button-semi-square"  
            attr.aria-label="{{'core.button.default_view' | translate}}" 
            matTooltip="{{'core.button.default_view' | translate}}"
            (click)="toggleView()">      
            <svg>
              <use xlink:href="#sx-konfigurera-widgets" href="#sx-konfigurera-widgets" />
            </svg>
          </button>

        </div>
      </div>

      <div class="sxl-align-left sx-table-filter__btngroup">
  
        <!-- Selected filters -->
        <div class="sx-filter sxl-space-between sx-metering-scope active" *ngIf="filterActive">
          <div class="sx-filter__bar sx-filter__bar-no-background sxl-grow sx-filter__bar-width50">
            <span *ngIf="filterDefinitions && filterDefinitions.length > 0">
              <div class="sx-filter__chip-wrapper sxh-horizontal-stack-tiny">
                <span style="font-size:14px">{{'invoices.filter.selected' | translate }}: </span>
                <span *ngFor="let filterDefinition of filterDefinitions">

                  <span *ngIf="filterDefinition.selected">
                    <span *ngFor="let selection of filterDefinition.selected">
                      <div class="sx-chip sx-chip--selected" >
                        {{selection}} <a (click)="removeFilter(filterDefinition, selection)">&nbsp;&#x2716;</a>
                      </div>
                    </span>
                  </span>
                </span>
                <!-- Remove all filters -->
                <div class="sx-chip sx-chip--button" >
                  <a (click)="clearFilter(f)">{{'invoices.filter.clear_filter' | translate }}</a>
                </div>
              </div>
            </span>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
